import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="autohide"
export default class extends Controller {
  connect() {
    setTimeout(() => {
      this.element.remove();
    }, 9000);
  }
}
